/** Общее для экранов «Техника» (поток 9): подписи, форматы, права на запись */
import { seesMoney, type UnitRow } from '@epc/contracts';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { tenge } from '../../lib/format';
import { useMe } from '../../lib/session';
import { Badge } from '../../ui/feedback';
import { useProjectsWith } from '../psd/shared';

export const n1 = (x: number | null | undefined) =>
  x == null ? '—' : (Math.round(x * 10) / 10).toLocaleString('ru-RU');
export const dd = (s: string | null | undefined) => (s ? s.slice(0, 10).split('-').reverse().join('.') : '—');
export const num = (s: string): number | null => {
  const v = Number(s.replace(/\s/g, '').replace(',', '.'));
  return s.trim() === '' || !Number.isFinite(v) ? null : v;
};
export const money = (x: number | null | undefined) => (x == null ? 'скрыто' : tenge(x));

/** Видит ли человек суммы (уровень денег «Акты») */
export function useMoney(): boolean {
  const me = useMe();
  return me.tenant?.staff === true && seesMoney(me.access, 'acts');
}

/** Проекты, где можно вести технику, и проекты, где можно сдавать путевые листы */
export function useFleetRights() {
  const edit = useProjectsWith('resources.edit');
  const waybill = useProjectsWith('site.report', 'resources.edit');
  const view = useProjectsWith('resources.view', 'site.view', 'site.report');
  return {
    view: view.list,
    canEdit: (projectId: string | null | undefined) =>
      !!projectId && edit.list.some((p) => p.id === projectId),
    canWaybill: (projectId: string | null | undefined) =>
      !!projectId && waybill.list.some((p) => p.id === projectId),
    anyEdit: edit.list.length > 0,
  };
}

export const unitsQuery = (projectId: string | undefined) => ({
  queryKey: ['fleet', 'units', projectId ?? ''],
  queryFn: () => api<UnitRow[]>('/fleet/units', { query: { projectId } }),
});

export function useUnits(projectId: string | undefined) {
  return useQuery(unitsQuery(projectId));
}

export function DocsBadge({ state }: { state: UnitRow['docsState'] }) {
  if (state === 'expired') return <Badge tone="danger">Документ просрочен</Badge>;
  if (state === 'soon') return <Badge tone="warning">Срок документа подходит</Badge>;
  return null;
}
